import { z } from 'zod';
/**
 * 产品级 SMTP 发信配置（#4）：谁负责谁发送。
 * 必配：产品无此配置则不发信、不回退 SES。授权码 KMS 加密存、不回显。
 */
export const EmailConfigSchema = z.object({
    from_email: z.string().trim().email().max(254), // 发件邮箱（信封 From）
    from_name: z.string().trim().max(100).optional(), // 显示名
    smtp_host: z.string().trim().min(1).max(200), // 如 smtp.exmail.qq.com
    smtp_port: z.number().int().min(1).max(65535), // 465 / 587 / 25
    smtp_secure: z.boolean().default(true), // 465=true(SSL) / 587=false(STARTTLS)
    // 明文发送：不启用 STARTTLS（即使服务器支持）。用于跨境链路上「加密 SMTP 被中间设备 reset、
    // 但明文放行」的自建邮箱（如部分中国企业邮）。⚠️ 密码与正文以明文传输，仅在必要时开启。
    smtp_ignore_tls: z.boolean().default(false),
    smtp_user: z.string().trim().min(1).max(254), // SMTP 登录用户名
    // 认证方式：password=登录密码 / auth_code=授权码（应用专用密码）。仅影响文案，底层都作为 pass 发送。
    auth_type: z.enum(['password', 'auth_code']).default('password'),
    reply_to: z.string().trim().email().max(254).optional(),
});
/**
 * 保存配置输入：smtp_pass（授权码）仅在「设置/修改密码」时传；
 * 不传表示沿用已存的密码（编辑其它字段时不必重填）。
 */
export const SaveEmailConfigSchema = EmailConfigSchema.extend({
    smtp_pass: z.string().min(1).max(512).optional(),
});
/** 发送测试邮件 */
export const SendTestEmailSchema = z.object({
    to: z.string().email().max(254),
});
/** 补发 BOM/ECN 通知时可选的自定义主题/正文（留空用默认） */
export const NotifyContentSchema = z
    .object({
    subject: z.string().max(200).optional(),
    body: z.string().max(5000).optional(),
})
    .strict();
/** 从「我的发件邮箱簿」选一个已保存账号应用到当前产品 */
export const ApplySmtpAccountSchema = z
    .object({
    account_id: z.string().min(1).max(128),
})
    .strict();
//# sourceMappingURL=email-config.js.map